import {define} from './define'
import type {FieldsetReturn} from '../types'

export const seo = (): FieldsetReturn => define('seo', {title: 'SEO', options: {collapsed: false}})
